import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

// A one-shot deep-link param (e.g. ?edit=4): handed to onValue once `ready`, then removed.
export function useConsumeSearchParam(name: string, onValue: (value: string) => void, ready = true) {
  const [params, setParams] = useSearchParams();
  const value = params.get(name);
  const callback = useRef(onValue);
  callback.current = onValue;

  // StrictMode re-runs the effect before the URL update lands; re-armed once the param is gone.
  const consumed = useRef(false);

  useEffect(() => {
    if (!value) {
      consumed.current = false;
      return;
    }
    if (!ready || consumed.current) return;
    consumed.current = true;
    callback.current(value);
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(name);
        return next;
      },
      { replace: true }
    );
  }, [ready, value, name, setParams]);
}
